import * as Mutation from './mutation-types'
import { getEventIndexById } from './utils'
export default {
    TOGGLE_LOADING (state, status) {
        state.callingAPI = status
    },
    TOGGLE_SEARCHING (state) {
        state.searching = (state.searching === '') ? 'loading' : ''
    },
    SET_USER (state, user) {
        state.user = user
    },
    SET_TOKEN (state, token) {
        state.token = token
    },
    [Mutation.CREATE_EVENT] (state, event) {
        return state.events.push(event)
    },
    [Mutation.UPDATE_EVENT] (state, updatedEvent) {
        const index = getEventIndexById(state, updatedEvent.id)

        if (index === -1) {
            return console.warn(`Unable to update event (id ${updatedEvent.id})`)
        }

        return state.events.splice(index, 1, {
            ...state.events[index],
            title: updatedEvent.title,
            start: updatedEvent.start,
            end: updatedEvent.end,
            date: updatedEvent.date,
            time: updatedEvent.time,
            project: updatedEvent.project,
            extendedProps: updatedEvent.extendedProps,
        })
    },
    [Mutation.DELETE_EVENT] (state, eventId) {
        const index = getEventIndexById(state, eventId)

        if (index === -1) {
            return console.warn(`Unable to delete event (id ${eventId})`)
        }

        return state.events.splice(index, 1)
    },
    [Mutation.SET_WEEKENDS_ENABLED] (state, enabled) {
        state.weekendsVisible = enabled
    },
    [Mutation.SCROLL_BEHAVIOR] (state, enabled) {
        state.hide_scroll = enabled
    },
    [Mutation.AUTH_REQUEST]: (state) => {
        state.status = 'loading'
    },
    [Mutation.AUTH_SUCCESS]: (state, userProfile) => {
        state.status = 'success'
        state.token = userProfile.token
        state.userProfile = userProfile
        state.empId = userProfile.data.attributes.emp_id
        state.userId = userProfile.user_id
        // localStorage.setItem("emp-id", userProfile.data.attributes.emp_id )
        // localStorage.setItem("user-id", userProfile.user_id)
        // localStorage.setItem("isMultiple", userProfile.data.attributes.is_multiple)
        // state.isMultiple = userProfile.data.attributes.is_multiple == 1 ? true : false
    },
    [Mutation.AUTH_ERROR]: (state) => {
        state.status = 'error'
    },
    [Mutation.AUTH_LOGOUT]: state => {
        state.profile = {};
        state.token = ""
        state.userProfile = {}
        state.empId = ""
        state.userId = ""
        state.isMultiple = false
        state.menus = []
        state.routes = []
        state.company_setting = {}
    },
    SET_PAGE(state, data){
        state.page = data.fullPath
    },
    COMPANY_SETTINGS(state, data){
        state.company_setting = data
    },
    [Mutation.UPDATE_PHOTO_PROFILE]: (state, photo_profile) =>{
        state.photo_profile = photo_profile
    },
    [Mutation.MENUS]:(state, menus) => {
        state.menus = menus
    },
    [Mutation.ROUTES]:(state, routes) => {
        state.routes = routes
    }
}